import { NodoDto } from "@/api";
import NodoCard from "@/components/NodoCard";
import Box from "@/elements/Box";
import Typography from "@/elements/Typography";
import { TextField } from "@mui/material";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

export default function ContenitoriTable({ 
  nodo
}: { 
  nodo: NodoDto;
}) {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");

  const nodiFigli = nodo.nodiFigli || [];
  const [allContenitori, contenitori] = useMemo(() => {
    const allContenitori = nodiFigli.filter((n) => n.tipo === "Contenitore");

    const cleanSearch = search.trim().toLowerCase();
    const contenitori = allContenitori.filter((n) => {
      return n.nome.toLowerCase().indexOf(cleanSearch) >= 0;
    });

    return [allContenitori, contenitori] as const;
  }, [nodiFigli, search]);

  return (
    <Box flex={1}>
      <Box display="flex" flexDirection="column" height="100%" gap={1}>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          gap={1}
        >
          <Typography variant="h5" color="text" fontWeight="medium">
            {t("nodoPage.contenitori.titolo")}
          </Typography>
          <Box flex={1} />
          <TextField
            placeholder={t("nodoPage.contenitori.filtroPlaceholder")}
            value={search}
            onChange={(e) => {
              setSearch(e.target.value || "");
            }}
            size="small"
          />
        </Box>
      </Box>

      <Box
        mt={2}
        mb={0}
        display="flex"
        flexDirection="row"
        flexWrap="wrap"
        gap={2}
      >
        {contenitori.map((contenitore) => {
          return (
            <NodoCard
              key={contenitore.id}
              nodo={contenitore}
            />
          );
        })}
      </Box>

      {contenitori.length === 0 ? (
        allContenitori.length === 0 ? (
          <Typography mt={2} variant="body2">
            {t("nodoPage.contenitori.vuoto")}
          </Typography>
        ) : (
          <Typography mt={2} variant="body2">
            {t("nodoPage.contenitori.nessunRisultato", { search })}
          </Typography>
        )
      ) : null}
    </Box>
  );
}
